// GuestFilterTabs.js
import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab, useMediaQuery, Badge } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const ReceptionFilterTabs = ({
  selectedSide,
  handleSideChange,
  selectedIsAttend,
  handleIsAttendChange,
  arr,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [filterCountList, setFilterCountList] = useState({
    all: 0,
    sideGroom: 0,
    sideBride: 0,
    checkinYes: 0,
    checkinYet: 0,
    checkinNo: 0,
  });

  const countGuests = () => {
    console.log(arr);

    let allCount = 0;
    let sideGroomCount = 0;
    let sideBrideCount = 0;
    let checkinYesCount = 0;
    let checkinNoCount = 0;
    let checkinYetCount = 0;

    // 'arr' 配列内の各アレンジメントについて処理
    arr.forEach((element) => {
      if (element.side === "groom") {
        sideGroomCount += element.guests.length;
      } else if (element.side === "bride") {
        sideBrideCount += element.guests.length;
      } else {
        console.error("Unknown type.");
      }

      // 各ゲストの参加状況をカウント
      element.guests.forEach((guest) => {
        allCount += 1;
        if (guest.is_attend === "yes") {
          checkinYesCount += 1;
        } else if (guest.is_attend === "no") {
          checkinNoCount += 1;
        } else if (guest.is_attend === "yet") {
          checkinYetCount += 1;
        } else {
          console.error("Unknown type.");
        }
      });
    });

    // 状態の更新
    setFilterCountList({
      all: allCount,
      sideGroom: sideGroomCount,
      sideBride: sideBrideCount,
      checkinYes: checkinYesCount,
      checkinNo: checkinNoCount,
      checkinYet: checkinYetCount,
    });

    console.log(filterCountList);
  };

  useEffect(() => {
    // コンポーネントがレンダリングされるたびにゲスト数をカウント
    countGuests();
  }, [arr]);

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedSide}
          onChange={handleSideChange}
          aria-label="guest filter tabs"
          textColor="secondary"
          indicatorColor="secondary"
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.primary.main,
              height: "3px",
            },
          }}
        >
          <Tab
            value="all"
            label={
              <Badge color="primary" badgeContent={filterCountList.all}>
                <Box style={{ padding: "0 6px 0 0" }}>全て</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px",
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 700, // アクティブ時の太さを変更
              },
            }}
          />
          <Tab
            value="groom"
            label={
              <Badge color="primary" badgeContent={filterCountList.sideGroom}>
                <Box style={{ padding: "0 6px 0 0" }}>新郎側</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px",
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 700,
              },
            }}
          />
          <Tab
            value="bride"
            label={
              <Badge color="primary" badgeContent={filterCountList.sideBride}>
                <Box style={{ padding: "0 6px 0 0" }}>新婦側</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px",
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 700,
              },
            }}
          />
        </Tabs>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedIsAttend}
          onChange={handleIsAttendChange}
          aria-label="guest filter tabs"
          textColor="secondary"
          indicatorColor="secondary"
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.primary.main,
              height: "3px",
            },
          }}
        >
          <Tab
            value="all"
            label={
              <Badge color="primary" badgeContent={filterCountList.all}>
                <Box style={{ padding: "0 6px 0 0" }}>全て</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px",
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 700,
              },
            }}
          />
          <Tab
            value="yes"
            label={
              <Badge color="primary" badgeContent={filterCountList.checkinYes}>
                <Box style={{ padding: "0 6px 0 0" }}>完了</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px",
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 700,
              },
            }}
          />
          <Tab
            value="yet"
            label={
              <Badge color="primary" badgeContent={filterCountList.checkinYet}>
                <Box style={{ padding: "0 6px 0 0" }}>未完了</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px",
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 700,
              },
            }}
          />
          <Tab
            value="no"
            label={
              <Badge color="primary" badgeContent={filterCountList.checkinNo}>
                <Box style={{ padding: "0 6px 0 0" }}>欠席</Box>
              </Badge>
            }
            sx={{
              color: theme.palette.text.secondary,
              minWidth: isSmallScreen ? "80px" : "90px",
              "&.Mui-selected": {
                color: theme.palette.text.primary,
                fontWeight: 700,
              },
            }}
          />
        </Tabs>
      </Box>
    </>
  );
};

export default ReceptionFilterTabs;
